import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';
import { Regional } from '../../../businness-intelligence/fluxo-leads/fluxo-leads.model';
@Injectable({
  providedIn: 'root'
})
export class VisaoLeadsServiceService extends ServiceBase {

  private baseUrlService: string
  private url: string;
  protected httpClient: HttpClient;
  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.httpClient = http;
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.url;
  }

  public setURL(url: string) {
    var temp = `${this.baseUrlService}` + url;
    this.url = temp;
  }

  private defineURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  public getFiltroDealers(): any {
    this.defineURLFiltroDealers();
    return this.get([]);
  }
  public buscarRegionais(): Promise<Regional[]> {
    const headers = new HttpHeaders({ 'Authorization': this.getToken() });
    
    return this.httpClient.get<any>(`${this.baseUrlService}/filtro/regional`, { headers })
      .toPromise()
      .then(res => {
        if (res && res.filtros) {
          return res.filtros;
        }
        return [];
      })
  }

  public getDados(
      data_inicial?: any,
      data_final?: any,
      dealers?: any,
      grupo_economico?: any,
      modelo_veic?: any,
      versao_veic?: any,
      nome_vendedor?: any,
      somente_fabrica?: any,
      id_regional?: any
      ): Observable<any> {
      let params = new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('id_grupo', grupo_economico.toString())
        .set('modelo_veic', modelo_veic.toString())
        .set('versao_veic', versao_veic.toString())
        .set('nome_vendedor', nome_vendedor.toString())
        .set('somente_fabrica', somente_fabrica.toString())
        .set('id_regional', id_regional.toString())
      
      return this.httpClient.get<any>(`${this.baseUrlService + '/funil_vendas_leads/'}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        }),
        params: params
      });
  }

  public getDadosInsucessos(
    data_inicial?: any, data_final?: any, dealers?: any, grupo_economico?: any, modelo_veic?: any, 
    versao_veic?: any, nome_vendedor?: any, somente_fabrica?: any, id_regional?: any
    ): Observable<any> {
    let params = new HttpParams()
      .set('data_inicial', data_inicial.toString())
      .set('data_final', data_final.toString())
      .set('dealers', dealers.toString())
      .set('id_grupo', grupo_economico.toString())
      .set('modelo_veic', modelo_veic.toString())
      .set('versao_veic', versao_veic.toString())
      .set('nome_vendedor', nome_vendedor.toString())
      .set('somente_fabrica', somente_fabrica.toString())
      .set('id_regional', id_regional.toString())
    
    return this.httpClient.get<any>(`${this.baseUrlService + '/funil_vendas_leads/insucessos'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: params
    });
}

  public getFluxo(data_inicial?: any,
      data_final?: any,
      dealers?: any,
      grupo_economico?: any,
      modelo_veic?: any,
      versao_veic?: any,
      nome_vendedor?: any,
      somente_fabrica?: any,
      id_regional?: any) : Observable<any> {
      let params = new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('id_grupo', grupo_economico.toString())
        .set('modelo_veic', modelo_veic.toString())
        .set('versao_veic', versao_veic.toString())
        .set('nome_vendedor', nome_vendedor.toString())
        .set('somente_fabrica', somente_fabrica.toString())
        .set('id_regional', id_regional.toString());
      
      return this.httpClient.get<any>(`${this.baseUrlService + '/funil_vendas_leads/etapas'}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        }),
        params: params
      });
  }
  
  public getMotivos(data_inicial?: any,
      data_final?: any,
      dealers?: any,
      grupo_economico?: any,
      modelo_veic?: any,
      versao_veic?: any,
      nome_vendedor?: any,
      somente_fabrica?: any,
      id_regional?: any) : Observable<any> {
      let params = new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('id_grupo', grupo_economico.toString())
        .set('modelo_veic', modelo_veic.toString())
        .set('versao_veic', versao_veic.toString())
        .set('nome_vendedor', nome_vendedor.toString())
        .set('somente_fabrica', somente_fabrica.toString())
        .set('id_regional', id_regional.toString());
      
      return this.httpClient.get<any>(`${this.baseUrlService + '/funil_vendas_leads/motivos'}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        }),
        params: params
      });
  }

  public getPrimeiroContato(data_inicial?: any,
      data_final?: any,
      dealer?: any,
      grupo_economico?: any,
      modelo_veic?: any,
      versao_veic?: any,
      nome_vendedor?: any,
      somente_fabrica?: any,
      id_regional?: any) : Observable<any> {
      let params = new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealer.toString())
        .set('id_grupo', grupo_economico.toString())
        .set('modelo_veic', modelo_veic.toString())
        .set('versao_veic', versao_veic.toString())
        .set('nome_vendedor', nome_vendedor.toString())
        .set('somente_fabrica', somente_fabrica.toString())
        .set('id_regional', id_regional.toString());
      
      return this.httpClient.get<any>(`${this.baseUrlService + '/funil_vendas_leads/primeiroContato'}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        }),
        params: params
      });
  }

  public getClassificacao(data_inicial?: any,
      data_final?: any,
      dealers?: any,
      grupo_economico?: any,
      modelo_veic?: any,
      versao_veic?: any,
      nome_vendedor?: any,
      somente_fabrica?: any,
      id_regional?: any) : Observable<any> {
      let params = new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('id_grupo', grupo_economico.toString())
        .set('modelo_veic', modelo_veic.toString())
        .set('versao_veic', versao_veic.toString())
        .set('nome_vendedor', nome_vendedor.toString())
        .set('somente_fabrica', somente_fabrica.toString())
        .set('id_regional', id_regional.toString());
      
      return this.httpClient.get<any>(`${this.baseUrlService + '/funil_vendas_leads/classificacao'}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        }),
        params: params
      });
  }

}
